

































































































































































































































































import mixins from 'vue-typed-mixins';
import vuelidateMixin from "@/mixins/vuelidateMixin";
import { required  , maxLength , email } from 'vuelidate/lib/validators';
import BoxContainer from "@/components/BoxContainer.vue";
import {UserViewModel} from "../../models/UserViewModel";

export default mixins( vuelidateMixin ).extend ( {
  name: "UserForm",
  components: {
    BoxContainer
  },
  props: {
    value: {
      type: Object as () => UserViewModel
    },
    formSaving: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'new'
    },
    municipalityList: {
      type: Array as () => any,
      default: null
    }
  },
  data(): {
    user: UserViewModel
    itemId: number
    metroVanOrMunicipal: string
  }{
    return{
      user: { ...this.value } as UserViewModel,
      itemId: 0,
      metroVanOrMunicipal: "",
    }
  },
  validations: {
    user: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required ,
        email
      },
      title: {
        required
      }
    }
  },
  computed: {
    isEditMode(): boolean {
      return ( this.mode === 'edit');
    },
    isMunicipalUser():boolean {
      let returnValue = false;
      if ( this.mode === 'edit') {
        if ( this.user.isMetroVanUser ) {
          returnValue = false;
        }
        if ( this.user.isMunicipalUser ) {
          returnValue = true;
        }
        return returnValue;
      }
      if ( this.mode === 'new') {
        if ( this.metroVanOrMunicipal === "Municipal") {
          returnValue = true;
        }
        return returnValue;
      }
      return returnValue;
    },
    isMetroVanUser():boolean {
      let returnValue = false;
      if ( this.mode === 'edit') {
        if ( this.user.isMetroVanUser ) {
          returnValue = true;
        }
        if ( this.user.isMunicipalUser ) {
          returnValue = false;
        }
        return returnValue;
      }
      if ( this.mode === 'new' ) {
        if ( this.metroVanOrMunicipal === "MetroVan") {
          returnValue = true;
        }
        return returnValue;
      }
      return returnValue;
    }
  },
  watch: {
    value: {
      handler() {
        this.user = { ...this.value }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    triggerValidation() {
      const valid = this.isValidWithNotification(this.$v.user);

      if ( valid ) {
        this.$emit('click');
      }
    },
  },
} )

